import { GridColDef } from '@mui/x-data-grid-premium';
import { IStockQuantityLocation } from 'features/inventory/stock/types';
import { useTranslation } from 'react-i18next';
import { dateFilterOperators } from '../../../components/enhanced/data-grid/utils/filters';
import { booleanCell } from '../../../components/cells/BooleanCell';
import { dateCell } from '../../../components/cells/date-cell';
import { createColumns } from '../../../components/enhanced/data-grid/utils/ConfigurableColumns';

export function StockQuantityLocationColumns(isAdmin = false): GridColDef[] {
  const { t } = useTranslation();
  return createColumns<IStockQuantityLocation>(
    [
      {
        field: 'product_code',
        width: 150
      },
      {
        field: 'product_description',
        width: 200
      },
      {
        field: 'quantity',
        width: 100,
        editable: isAdmin
      },
      {
        field: 'product_batch',
        width: 150
      },
      {
        field: 'expiration_date',
        width: 150,
        type: 'date',
        valueGetter: ({ value }) => (value ? new Date(value) : null),
        filterOperators: dateFilterOperators,
        renderCell: dateCell
      },
      {
        field: 'discounted',
        width: 100,
        type: 'boolean',
        renderCell: booleanCell(t)
      }
    ],
    t,
    'pages.locations.columns'
  );
}
